
<div style="position: relative">
    <p-inc-todo-card
        :item       = "item"
        :show-date  = "true"
        :date       = "item.dateRemedyOfDefects"
        :date-color = "prioColor"
        :height     = "114"
    >
        <template v-slot:comment>
            <v-divider class="mt-1 mb-1" />
            <div class="v-flex pr-4" style="margin-top: 2px;">
                <p-inc-assessment-card-faults
                    type       = "major"
                    :faults    = "item.majorFaults"
                    :confirmed = "item.majorFaultsConfirmed"
                />

                <p-inc-assessment-card-faults
                    type       = "middle"
                    :faults    = "item.middleFaults"
                    :confirmed = "item.middleFaultsConfirmed"
                />

                <p-inc-assessment-card-faults
                    type       = "minor"
                    :faults    ="item.minorFaults"
                    :confirmed = "item.minorFaultsConfirmed"
                />

                <v-spacer />

                <div class="assessment-date">
                    <div class="v-flex">
                        <div class="assessment-date-label">Prüfung am:</div><div>{{ dateAsString (item.date) }}</div>
                    </div>
                    <div class="v-flex">
                        <div class="assessment-date-label">Bearbeitet am:</div><div>{{ dateAsString (item.modifiedDate) }}</div>
                    </div>
                </div>
            </div>
        </template>
    </p-inc-todo-card>
</div>
